// extracted by mini-css-extract-plugin
export default {"pdfObjectContainer":"styles-module__pdfObjectContainer__src-labstep-web-core-PDFObject-_dDCZ6"};